import ToastService from '@/services/ToastService';

// Single funnel for transaction errors, usable in any `catch` across the app.
//
// - CONTROLLED errors (frontend validation, Firebase auth, business API errors)
//   return a message string so the caller can render it inline as a label.
// - UNCONTROLLED API exceptions — flagged `unhandled` by the backend — are shown
//   here as a PERSISTENT toast (no auto-dismiss: the user must close it), and the
//   function returns null so the caller sets no label. These are unexpected
//   failures worth keeping on screen until acknowledged, unlike a controlled
//   validation message the user can act on and clear inline.
//
// `error_id` is the backend correlation id for an uncontrolled exception.
// ToastService.Error already knows how to turn that into the caller's own
// `fallback` (action-specific text) + Ref/copy row, so the unhandled branch
// just delegates to it — passing `fallback` through so it isn't lost.
function Resolve(e, fallback = 'Ocurrió un error inesperado') {
    if (e?.unhandled) {
        ToastService.Error(e, fallback);
        return null;
    }

    return e?.message ?? fallback;
}

export default { Resolve };
